import {
  Chips,
  GridColumn,
  GridDataRow,
  GridTable,
  GridTableLayout,
  RowStyles,
  SimpleHeaderAndData,
  column,
  simpleDataRows,
} from "@homebound/beam";
import { useCallback, useMemo } from "react";
import { dateCell } from "src/components";
import {
  InvoiceTermsQuery,
  InvoiceTerms_InvoiceScheduleTemplatesFragment,
  useInvoiceTermsQuery,
} from "src/routes/billing/invoice-terms/components/InvoiceTermsTable.generated";
import { invoiceTermRoute } from "src/routing/domains/financesPaths";

export function InvoiceTermsTable() {
  const query = useInvoiceTermsQuery();
  const columns = useMemo(() => createColumns(), []);
  const createTableRows = useCallback(
    (data: InvoiceTermsQuery | undefined) => simpleDataRows(data?.invoiceScheduleTemplates ?? []),
    [],
  );

  return (
    <GridTableLayout
      hideEditColumns
      tableProps={{
        query,
        createRows: createTableRows,
        columns,
        rowStyles: createRowStyles(),
        emptyFallback: "No invoice terms found",
      }}
    />
  );
}

type InvoiceTermsTableViewProps = { invoiceScheduleTemplates: InvoiceTerms_InvoiceScheduleTemplatesFragment[] };

export function InvoiceTermsTableView({ invoiceScheduleTemplates }: InvoiceTermsTableViewProps) {
  const rows = useMemo(() => createRows(invoiceScheduleTemplates), [invoiceScheduleTemplates]);
  const columns = useMemo(() => createColumns(), []);
  return <GridTable rows={rows} columns={columns} style={{ allWhite: true }} rowStyles={createRowStyles()} />;
}

type Row = SimpleHeaderAndData<InvoiceTerms_InvoiceScheduleTemplatesFragment>;

function createColumns(): GridColumn<Row>[] {
  return [
    column<Row>({ header: "Term name", data: (row) => row.name, w: 2, mw: "200px" }),
    column<Row>({ header: "Product Type", data: (row) => row.lotType.code, w: "130px", mw: "130px" }),
    column<Row>({ header: "Community Type", data: (row) => row.communityType?.name, w: "140px", mw: "140px" }),
    column<Row>({ header: "Customer", data: (row) => row.customer?.name, w: 1.5, mw: "160px" }),
    column<Row>({
      header: "Regions",
      data: (row) => <Chips values={row.regions.map((region) => region.name)} />,
      w: 1.5,
      mw: "160px",
    }),
    column<Row>({ header: "Created On", data: (row) => dateCell(row.createdAt), w: "120px", mw: "120px" }),
  ];
}

function createRows(data: InvoiceTerms_InvoiceScheduleTemplatesFragment[]): GridDataRow<Row>[] {
  return simpleDataRows(data);
}

function createRowStyles(): RowStyles<Row> {
  return { header: {}, data: { rowLink: ({ id }) => invoiceTermRoute.url({ idOrAdd: id }) } };
}
